import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import player from 'lottie-web';
import { LottieModule } from 'ngx-lottie';

import { CommonModule } from '@angular/common';
import { RouteReuseStrategy } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DetailPageModule } from './detail-page/detail-page.module';
import { CustomReuseStrategy } from './reuse-strategy.route';
import HttpLoaderFactory from './shared/HttpLoaderFactory';
import { HttpGeneralInterceptor } from './shared/interceptors/http-general.interceptor';
import { AppLoadService } from './shared/services/app-load.service';
import { SimplePlayerComponent } from './shared/shared-components/simple-player/simple-player.component';
import { SharedModule } from './shared/shared.module';
import { ShimmerModule } from './shimmer/shimmer.module';
import { StorefrontModule } from './storefront/storefront.module';
import { AppLoaderComponent } from './z-app-loader/app-loader.component';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [AppComponent, SimplePlayerComponent, AppLoaderComponent],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    BrowserModule,
    MatDialogModule,
    AppRoutingModule,
    DetailPageModule,
    SharedModule,
    StorefrontModule,
    ShimmerModule,
    LottieModule.forRoot({ player: playerFactory }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    AppLoadService,
    {
      provide: APP_INITIALIZER,
      useFactory: (appConfigService: AppLoadService) => {
        return () => {
          //Make sure to return a promise!
          return appConfigService.initializeApp();
        };
      },
      deps: [AppLoadService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpGeneralInterceptor,
      multi: true,
    },
    // Implement RouteReuseStrategy if needed previous project uses in storefront component
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    { provide: Window, useValue: window },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
